"use client";

import { c as _c } from "react/compiler-runtime";
import { parseIpfsUrl } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
interface CarouselActiveItemDetailsProps {
  readonly drop: ExtendedDrop | null;
}
export default function CarouselActiveItemDetails(t0) {
  const $ = _c(24);
  const {
    drop
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const dropId = drop?.id;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsExpanded(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== dropId) {
    t2 = [dropId];
    $[1] = dropId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!drop) {
    return null;
  }
  const title = drop.metadata.find(_temp)?.data_value ?? drop.title ?? "Untitled";
  const description = drop.metadata.find(_temp2)?.data_value ?? "";
  const detailsId = `carousel-details-${drop.id}`;
  const author = drop.author;
  const t3 = `/waves?wave=${drop.wave.id}&drop=${drop.id}`;
  let t4;
  if ($[3] !== t3 || $[4] !== title) {
    t4 = <Link prefetch={false} href={t3} className="tw-mb-2 tw-block tw-text-center tw-text-lg tw-font-semibold tw-text-white tw-no-underline desktop-hover:hover:tw-text-white md:tw-text-xl">{title}</Link>;
    $[3] = t3;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `/${author.handle ?? author.primary_address}`;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-sm tw-text-iron-400">by</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== author.handle || $[8] !== author.pfp) {
    t7 = author.pfp ? <div className="tw-flex tw-size-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-md tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950"><Image className="tw-max-h-full tw-max-w-full tw-object-cover" src={getScaledImageUri(parseIpfsUrl(author.pfp), ImageScale.W_AUTO_H_50)} alt={author.handle ?? "Author avatar"} width={28} height={28} sizes="28px" /></div> : <div className="tw-size-6 tw-flex-shrink-0 tw-rounded-md tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900" />;
    $[7] = author.handle;
    $[8] = author.pfp;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== author.handle) {
    t8 = <span className="tw-text-sm tw-font-medium tw-text-iron-300 tw-transition desktop-hover:hover:tw-text-white">{author.handle}</span>;
    $[10] = author.handle;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t7 || $[14] !== t8) {
    t9 = <Link prefetch={false} href={t5} className="tw-flex tw-items-center tw-gap-x-2 tw-no-underline">{t6}{t7}{t8}</Link>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== description || $[17] !== detailsId || $[18] !== isExpanded) {
    t10 = description && <><button type="button" onClick={() => setIsExpanded(_temp3)} aria-expanded={isExpanded} aria-controls={detailsId} className="tw-group tw-mt-3 tw-inline-flex tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-text-base tw-font-medium tw-text-iron-500 tw-transition hover:tw-text-iron-300"><span>{isExpanded ? "Less" : "More"}</span><ChevronDownIcon className={`tw-size-3 tw-transition-transform ${isExpanded ? "tw-rotate-180" : ""}`} aria-hidden={true} /></button><div id={detailsId} className={`tw-grid tw-transition-all tw-duration-300 tw-ease-out ${isExpanded ? "tw-mt-3 tw-grid-rows-[1fr] tw-opacity-100" : "tw-grid-rows-[0fr] tw-opacity-0"}`}><div className="tw-overflow-hidden"><p className="tw-max-w-prose tw-text-balance tw-text-center tw-text-base tw-font-normal tw-leading-relaxed tw-text-iron-300">{description}</p></div></div></>;
    $[16] = description;
    $[17] = detailsId;
    $[18] = isExpanded;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t4 || $[22] !== t9) {
    t11 = <div className="tw-mx-auto tw-flex tw-w-full tw-max-w-2xl tw-flex-col tw-items-center tw-px-4 tw-py-4 md:tw-px-6 lg:tw-px-8">{t4}{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t4;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
function _temp3(prev) {
  return !prev;
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp(m) {
  return m.data_key === "title";
}